import { TrackingStore } from '@/hooks/use-tracking/store'

export const qParamsSelector = (state: TrackingStore) => {
  return {
    qParams: state.queryParams,
    setQueryParams: state.setQueryParams,
    deleteKeyFromParam: state.deleteKeyFromParam,
    reset: state.reset,
  }
}
export const currentStepSelector = (state: TrackingStore) => {
  return {
    currentStep: state.currentStep,
    setCurrentStep: state.setCurrentStep,
  }
}
